export default "__VITE_ASSET__DPvbDVp9__"